
const $slider_btns = document.querySelectorAll("#slider-nav-btn");

// const handleSliderNavClick = ($btn) => {
//   const $slider = $btn.parentElement.parentElement.querySelector("#slider");
//   const sliderScrollAmount = $slider.offsetWidth;
//   const sliderItemWidth = $slider.querySelector("li").offsetWidth;
//   const sliderItemsCount = $slider.querySelectorAll("li").length;
// };

const handleSliderNavClick = (e) => {
  const $btn = e.target.closest("button");
  
    // direction: "next" or "prev"
  const dir = ($btn.dataset?.dir || "").toLowerCase() === "prev" ? -1 : 1;
  

//  const $slider = $btn.closest(".slider-wrapper")?.querySelector("#slider");
const $slider = $btn.parentElement.parentElement.parentElement.querySelector("#slider");

  if (!$slider) return;

  const items = Array.from($slider.querySelectorAll("li"));

  if (!items.length) return;

  const containerWidth = $slider.clientWidth;
  const scrollLeft = $slider.scrollLeft;
  

  // find first partially-or-fully visible item index
  let firstVisibleIndex = items.findIndex((it) => {
    const left = it.offsetLeft;
    const right = left + it.offsetWidth;
    return right > scrollLeft && left < scrollLeft + containerWidth;
  });

  // if none (weird), fallback to 0 or last depending on direction
  if (firstVisibleIndex === -1) {
    firstVisibleIndex = dir > 0 ? 0 : items.length - 1;
  }

  // count how many items are visible (including partially visible)
  const visibleCount = Math.max(
    1,
    items.reduce((acc, it) => {
      const left = it.offsetLeft;
      const right = left + it.offsetWidth;
      return acc + (right > scrollLeft && left < scrollLeft + containerWidth ? 1 : 0);
    }, 0)
  );

  // decide target index: move by a "page" (number of visible items)
  let targetIndex = firstVisibleIndex + dir * visibleCount;

  // clamp
  targetIndex = Math.max(0, Math.min(items.length - 1, targetIndex));

  // If targetIndex equals firstVisibleIndex (e.g., at edges) try nudging by one
  if (targetIndex === firstVisibleIndex) {
    targetIndex = Math.max(0, Math.min(items.length - 1, firstVisibleIndex + dir));
  }

  // compute target scrollLeft so that target item sits at container left
  const targetItem = items[targetIndex];
  let targetScrollLeft = targetItem.offsetLeft;

  // If we are near the end, ensure we don't leave an empty gap on the right:
  // max scrollLeft = totalContentWidth - containerWidth
  const totalWidth = items[items.length - 1].offsetLeft + items[items.length - 1].offsetWidth;
  const maxScrollLeft = Math.max(0, totalWidth - containerWidth);
  if (targetScrollLeft > maxScrollLeft) targetScrollLeft = maxScrollLeft;

  // Smooth scroll
  $slider.scrollTo({ left: targetScrollLeft, behavior: "smooth" });
};

$slider_btns.forEach(($btn) => {
  $btn.addEventListener("click", (e) => handleSliderNavClick(e));
});

